/**
 * Input1 - Simple checkbox with label
 *
 * Renders a checkbox with a text label in a list-group-item container.
 *
 * @param {Object} props
 * @param {boolean} props.checked - Whether checkbox is checked by default
 * @param {string} props.text - Label text displayed next to checkbox
 * @param {function} props.onChange - Change event handler
 * @returns {React.ReactElement} Rendered checkbox list item
 */
function Input1({checked , text, onChange}){
  return(
    <li className="list-group-item border-0 px-0">
      <div className="form-check form-check-info text-left">
        <input className="form-check-input" type="checkbox" value="" onChange={onChange} defaultChecked={checked}/>
        <label className="form-check-label" >
          {text}
        </label>
      </div>
    </li>
  )
}

export default Input1
